import { Toaster } from "@/components/ui/sonner";
import { HeaderNav } from "@/components/HeaderNav";
import { KineticHero } from "@/components/KineticHero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { GoogleReviewsSection } from "@/components/GoogleReviewsSection";
import { ExpertiseManifesto } from "@/components/ExpertiseManifesto";
import { ClippedGallery } from "@/components/ClippedGallery";
import { QuoteSection } from "@/components/QuoteSection";
import { ArtisanFooter } from "@/components/ArtisanFooter";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#F5F3EE]">
      <Toaster position="top-center" richColors />
      <HeaderNav />
      <KineticHero />
      <EditorialMarquee />
      <GoogleReviewsSection />
      <ExpertiseManifesto />
      <ClippedGallery />
      <QuoteSection />
      <ArtisanFooter />
    </div>
  );
}
